import { render, staticRenderFns } from "./FooterBackersAndPartners.vue?vue&type=template&id=151155f6&"
import script from "./FooterBackersAndPartners.vue?vue&type=script&lang=js&"
export * from "./FooterBackersAndPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports